import React, { Component } from 'react';
import { useNavigate } from 'react-router-dom';
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  // componentDidCatch(error, errorInfo) {

  //   console.error('Error caught by ErrorBoundary:', error, errorInfo);
  // }

  componentDidCatch() {
    // If authentication was cleared while a protected page was rendering,
    // recover at the login screen instead of showing the generic crash page.
    if (!localStorage.getItem('user') && window.location.pathname !== '/login') {
      window.location.replace('/login');
    }
  }

  handleButtonClick = () => {
    const { navigateToSalesOrder } = this.props;
    navigateToSalesOrder();
  };

  render() {
    if (this.state.hasError) {
      // Render a centered message and a button for navigation
      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
          <p>Something went wrong. Navigating to the home page...</p>
          <button style={{ width: '20%' }} onClick={this.handleButtonClick}>
            Go to Home Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default function ErrorBoundaryWithNavigation(props) {
  const navigate = useNavigate();
  const navigateToSalesOrder = () => {
    navigate('/report-dashboard', { replace: true });
    window.location.reload();
  };

  return <ErrorBoundary {...props} navigateToSalesOrder={navigateToSalesOrder} />;
}
